import {Navigate, Route, Routes, useLocation} from "react-router-dom";
import React, {useEffect} from "react";
import {
    ACCESSIBILITY_STATEMENT_PATH,
    ACMG_STATUS_APP_PATH,
    LOGIN_APP_PATH,
    PATIENT_DATA_STORAGE_ITEM_NAME
} from "../consts/consts";
import Authorization from "./Authorization";
import AcmgReportStatus from "./AcmgReportStatus";
import AccessibilityStatement from "./AccessibilityStatement";

const AppRoutes = (props: any) => {
    const location = useLocation();

    useEffect(() => {
        const storedAcmgReportStatus = sessionStorage.getItem(PATIENT_DATA_STORAGE_ITEM_NAME);
        if (storedAcmgReportStatus) {
            props.setAcmgReportStatus(JSON.parse(storedAcmgReportStatus));
        }
    // eslint-disable-next-line
    }, [location]);

    const loginElement = (
        <Authorization
            showVerification={props.showVerification}
            setShowVerification={props.setShowVerification}
            setAcmgReportStatus={props.setAcmgReportStatus}
            inputId={props.inputId}
            inputPhone={props.inputPhone}
            setInputId={props.setInputId}
            setInputPhone={props.setInputPhone}
            sessionId={props.sessionId}
            setSessionId={props.setSessionId}
            onExit={props.logout}
            showModal={props.showModal}
            setShowModal={props.setShowModal}
        />
    );

    const acmgStatusElement = (
        <AcmgReportStatus
            acmgReportStatus={props.acmgReportStatus}
            setAcmgReportStatus={props.setAcmgReportStatus}
        />
    );

    let routes;
    if (props.acmgReportStatus && props.acmgReportStatus.status !== -1) {
        routes = (
            <Routes>
                <Route path={ACMG_STATUS_APP_PATH} element={acmgStatusElement}/>
                <Route path={ACCESSIBILITY_STATEMENT_PATH} element={<AccessibilityStatement/>}/>
                <Route path="/*" element={<Navigate to={ACMG_STATUS_APP_PATH}/>}/>
            </Routes>
        );
    } else {
        routes = (
            <Routes>
                <Route path={LOGIN_APP_PATH} element={loginElement}/>
                <Route path={ACCESSIBILITY_STATEMENT_PATH} element={<AccessibilityStatement/>}/>
                <Route path="/*" element={<Navigate to={LOGIN_APP_PATH} replace/>}/>
            </Routes>
        );
    }

    return routes;
}


export default AppRoutes;